import style from './index.module.scss';
import { constructLocalClasses } from '@lib/helpers';

/**
 * Button component.
 * @param {object} Props Deconstructed props.
 * @returns
 */
export default function Btn({ children, customClass = [], onClick, customId = '', disabled = false, ...rest }) {
	// Add dynamic classes.
	let btnClasses = constructLocalClasses(style, customClass);

	return (
		<button
			{...rest}
			onClick={onClick}
			{...(customId && { id: customId })}
			className={`${btnClasses} btnComponent`}
			disabled={true === disabled ? true : undefined}
		>
			{children}
		</button>
	);
}
